// Modules
import { gql } from '@apollo/client'

export const SearchLoginByCPF = gql`
    query viewerSearchLoginByCPF($username: String!) {
        viewerSearchLoginByCPF(username: $username) {
            mobile
        }
    }
`
export const ValidateLoginContact = gql`
    query validateLoginContact($contactType: ContactTypes!, $contactValue: String!) {
        validateLoginContact(contactType: $contactType, contactValue: $contactValue) {
            status
        }
    }
`
export const VerifyPreUserRegistration = gql`
    query viewerSearch($patient: PatientSearch!) {
        viewerSearch(patient: $patient) {
            id
            phone
            biologicalSex
            cep
            phoneContacts {
                id
                contactType
                value
            }
            emailContacts {
                id
                contactType
                value
            }
        }
    }
`
export const CheckAccount = gql`
    query checkAccount($userName: String!, $birthDate: String) {
        checkAccount(userName: $userName, birthDate: $birthDate) {
            status
            federalTaxId
            hasCipPassword
            accountSearch {
                id
                phoneContacts {
                    id
                    contactType
                    value
                }
                emailContacts {
                    id
                    contactType
                    value
                }
            }
            accountLoginSearch {
                mobile
                email
            }
        }
    }
`

export const ContactsToReset = gql`
    query contactsToReset($userName: String!) {
        contactsToReset(userName: $userName) {
            id
            type
            contact
        }
    }
`
